var React = require('react');

function KeypadAway (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.578 13.414h7.266v-6.418l-4.844-4.76-4.844 4.76v6.418zm2.422-13.414 8 7.86h-1.542v7.14h-12.916v-7.14h-1.542z","fill":"currentColor"}));
}

KeypadAway.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = KeypadAway;

KeypadAway.default = KeypadAway;
